import styled from 'styled-components';
import breakpoint from 'constants/breakpoints';

export const LinePageHeaderContainer = styled.header`
  padding-bottom: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1em;
`;
